import { compact, flatten, get, isArray, map, sum } from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Modals from 'react-bootstrap/Modal'
import 'react-calendar/dist/Calendar.css'
import 'react-date-picker/dist/DatePicker.css'
import { toast } from 'react-hot-toast'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { KTIcon, formatNumber } from '../../../../_metronic/helpers'
import { useLayout } from '../../../../_metronic/layout/core'
import { CardsWidget7 } from '../../../../_metronic/partials/widgets'
import { useLoaderContext } from '../../loaders/LoaderProvider'
import { ProductLedger } from '../../product-master/ledger/api'
import { CreateEditLedger } from '../../product-master/ledger/CreateEditLedger'
import { Loader } from '../../product-master/loader'
import {
  CreateReferenceBody,
  CreateTransactionBody,
  IndividualTransaction,
  SetOffInvoiceResp,
  VoucherTypeMap,
  createNewTransaction,
  createTransaction,
  getAccountingDetails,
  getExchangeRate
} from '../API/EnterTransactionsAPI'
import './Style.css'
import { TransactionRow } from './TransactionRow'
function hasDuplicateTransactionType(arr: any, ledgerMapping: any) {
  const seen = new Set()
  // console.log(arr)
  // console.log(ledgerMapping)
  if (!ledgerMapping) return false
  for (const obj of arr) {
    const key = ledgerMapping?.[obj.parentLedger]?.[obj.subLedger || 'None']
    // const key = `${obj.parentLedger}-${obj.subLedger}`

    if (seen.has(key)) {
      return true // Duplicate found, exit early
    }

    seen.add(key)
  }

  return false // No duplicates found
}

const isNaReferenceAmount = (amt1: number, amt2: number, amt3: number) => {
  if (amt1 - amt2 - amt3 > 0) return true
  return false
}

type OptionType = {
  value: string | null
  label: string
}

interface IStockInData {
  warehouse: string;
  product: string;
  quantity: number;
  sourceType: string;
  referenceDoc: string;
  dateOfEntry: string;
  batchNumber: string;
  purchaseAmount: number;
  uploadDocument: File | null; // Added for the file upload
}

interface IStockOutData {
  warehouse: string;
  product: string;
  quantity: number;
  destination: string;
  referenceDocNumber: string;
  uploadDocument: File | null;
  saleAmount: number;
  batchExpiry: string;
}

interface IStockAdjustmentData {
  warehouse: string;
  product: string;
  adjustmentType: 'Addition' | 'Reduction' | '';
  quantity: number;
  value: number;
  reasonCode: string;
  approver: string;
}

export const Transaction: React.FC<{activeTab: keyof VoucherTypeMap}> = ({activeTab}) => {
  const {loading, setLoading, error, setError} = useLoaderContext()

  const navigate = useNavigate()
  const location = useLocation()
  const {company, financialYear} = useLayout()
  const [errorMessage, setErrorMessage] = useState('')
  const [dbId, setDbId] = useState<number>()
  const [currencyModal, setCurrencyModal] = useState(false)
  const [setOffModal, setSetOffModal] = useState(false)
  const [previousPath, setPreviousPath] = useState('')
  const [voucherName, setVoucherName] = useState<OptionType>()
  // console.log(voucherName)
  const [voucherNumber, setVoucherNumber] = useState<number>()
  const [previousVoucherType, setPreviousVoucherType] = useState<string>()
  const [currency, setCurrency] = useState<OptionType>()
  const [prevCurrency, setPrevCurrency] = useState<OptionType>()
  const [isValidDate, setIsValidDate] = useState(true)
  const [voucherDate, setVoucherDate] = useState(new Date().toISOString().split('T')[0])
  const [voucherNumberMapping, setVoucherNumberMapping] = useState()
  const initialData: IndividualTransaction[] = [
    {
      transactionType: 'debit',
      parentLedger: '',
      subLedger: null,
      amount: 0,
      transactionAmount: 0,
      ledgerCode: '',
    },
    {
      transactionType: 'credit',
      parentLedger: '',
      subLedger: null,
      amount: 0,
      transactionAmount: 0,
      ledgerCode: '',
    },
  ]
  const [data, setData] = useState<IndividualTransaction[]>(initialData)
  const [nextDisabled, setNextDisabled] = useState(true)
  const [createLedger, setCreateLedger] = useState(false)
  const [narration, setNarration] = useState('')
  const [reportingCurrency, setReportingCurrency] = useState('')
  const [invoiceNumber, setInvoiceNumber] = useState<string>()
  const [invoiceDescription, setInvoiceDescription] = useState<string>()

  const [voucherOptions, setVoucherOptions] = useState<OptionType[]>([])
  const [byLedgerDetails, setByLedgerDetails] = useState<Record<string, string[]>>()
  const [toLedgerDetails, setToLedgerDetails] = useState<Record<string, string[]>>()
  const [ledgerCurrentBalanceMapping, setLedgerCurrentBalanceMapping] =
    useState<Record<string, Record<string, string>>>()
  const [ledgerMapping, setLedgerMapping] = useState()
  const [voucherMapping, setVoucherMapping]: any = useState()
  const [currencyOptions, setCurrencyOptions] = useState<OptionType[]>([])
  const [exchangeRate, setExchangeRate] = useState<{
    exchangeRate: number
    asOnDate: string
  }>()
  const [invoiceDetails, setInvoiceDetails] = useState<SetOffInvoiceResp[]>()
  const [editLedger, setEditLedger] = useState<ProductLedger | undefined>(undefined)
  const [applicableRate, setApplicableRate] = useState(0)
  const [updateExchangeRate, setUpdateExchangeRate] = useState(false)
  const [setOffDone, setSetOffDone] = useState(false)
  const [setOffTotalAmount, setSetOffTotalAmount] = useState(0)
  const [status, setStatus] = useState(false)
  const [modal, setModal] = useState(false)
  const [lastCompanyId, setLastCompanyId] = useState<string | null>(null)
  // Add new state
  const [shouldRefreshLedgers, setShouldRefreshLedgers] = useState(true)
  const [isInventoryItem, setIsInventoryItem] = useState(false)
  const [stockInData, setStockInData] = useState<IStockInData>({
    warehouse: '',
    product: '',
    quantity: 0,
    sourceType: 'Purchase',
    referenceDoc: '',
    dateOfEntry: new Date().toISOString().split('T')[0],
    batchNumber: '',
    purchaseAmount: 0,
    uploadDocument: null,
  });



const [stockOutData, setStockOutData] = useState<IStockOutData>({
  warehouse: '',
  product: '',
  quantity: 0,
  destination: '',
  referenceDocNumber: '',
  uploadDocument: null,
  saleAmount: 0,
  batchExpiry: '',
});
  
const [isStockAdjustment, setIsStockAdjustment] = useState(false);
const [stockAdjustmentData, setStockAdjustmentData] = useState<IStockAdjustmentData>({
  warehouse: '',
  product: '',
  adjustmentType: '',
  quantity: 0,
  value: 0,
  reasonCode: '',
  approver: '',
});
  
  useEffect(() => {
    if (!isInventoryItem) {
      setStockInData({
        warehouse: '',
        product: '',
        quantity: 0,
        sourceType: 'Purchase',
        referenceDoc: '',
        dateOfEntry: new Date().toISOString().split('T')[0],
        batchNumber: '',
        purchaseAmount: 0,
        uploadDocument: null,
      });
      setStockOutData({
        warehouse: '',
        product: '',
        quantity: 0,
        destination: '',
        referenceDocNumber: '',
        uploadDocument: null,
        saleAmount: 0,
        batchExpiry: '',
      });
    }
  }, [isInventoryItem]);

  useEffect(() => {
    if (!isStockAdjustment) {
      setStockAdjustmentData({
        warehouse: '',
        product: '',
        adjustmentType: '',
        quantity: 0,
        value: 0,
        reasonCode: '',
        approver: '',
      });
    }
  }, [isStockAdjustment]);

  const [availableStock, setAvailableStock] = useState<string | number>('Select product to see stock');

  const { byTotal: debitTotal, toTotal: creditTotal } = useMemo(() => {
    const byTotal = data.reduce((acc, val) => {
      acc = acc + (val.transactionType === 'debit' ? val.amount : 0)
      return acc
    }, 0)
    const toTotal = data.reduce((acc, val) => {
      acc = acc + (val.transactionType === 'credit' ? val.amount : 0)
      return acc
    }, 0)

    return { byTotal, toTotal }
  }, [data]);

  useEffect(() => {
    if (status) {
      setModal(true)
    }
  }, [location])

 useEffect(() => {
    if (isInventoryItem) {
      setStockInData(prevData => ({ ...prevData, purchaseAmount: debitTotal }));
      setStockOutData(prevData => ({ ...prevData, saleAmount: creditTotal }));
    }
  }, [isInventoryItem, debitTotal, creditTotal]);
  
useEffect(() => {
    setIsInventoryItem(false);
    if (activeTab !== 'journal') {
      setIsStockAdjustment(false);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!!location.state) {
      const state = location.state as {transaction: any}
      // console.log(state)
      const transaction = state?.transaction
      setDbId(transaction?.dbId)
      setPreviousVoucherType(transaction.voucherType)
      setCurrency({
        value: transaction?.transactingCurrency,
        label: transaction?.transactingCurrency,
      })
      !!transaction?.voucherName &&
        setVoucherName({value: transaction?.voucherName, label: transaction?.voucherName})
      setVoucherDate(transaction?.voucherDate)
      setVoucherNumber(transaction?.voucherNumber)
      setInvoiceDetails(transaction?.invoiceDetails)
      // setInvoiceNumber(transaction?.invoiceNumber.toString())
      // setInvoiceDescription(transaction?.invoiceDescription)
      const transactionDetails: IndividualTransaction[] = transaction.transactionDetails.map(
        (t: any) => {
          return {
            parentLedger: t.parentLedger,
            subLedger: t.subLedger,
            amount: t.transactionAmount / transaction.exchangeMultiplier,
            transactionType: t.transactionType,
          }
        }
      )
      setData(transactionDetails)
      setNarration(transaction.narration || '')
      setExchangeRate({
        exchangeRate: transaction.exchangeMultiplier,
        asOnDate: transaction.voucherDate,
      })
      let otherVouchersData
      if (transaction.voucherType !== 'sales' && transaction.voucherType !== 'purchase') {
        otherVouchersData = transaction.transactionDetails.map((tr: any, i: any) => {
          return {
            advanceDetails: transaction.advanceDetails
              ?.filter((adv: any) => adv.parent_ledger === tr.parentLedger && i > 0)
              .map((adv: any) => {
                if (adv)
                  return {
                    advanceNumber: adv.advance_number,
                    amount: adv.advance_amount,
                    dateOfAdvance: adv.advance_date,
                    remarks: adv.advance_description,
                    transactionType: adv.transaction_type,
                  }
                return undefined
              })
              .map((el: any) => el)[0],

            againstInvoiceDetails: transaction?.againstInvoiceDetails
              ?.filter((inv: any) => inv.parent_ledger === tr.parentLedger)
              .map((_: any, i: number) => {
                return {
                  invoiceAmount: _.invoice_amount,
                  invoiceDate: _.invoice_date,
                  invoiceDueDate: _.invoice_due_date,
                  invoiceNumber: _.invoice_number,
                  remarks: _.remarks,
                  settOffAmount: _.settOffAmount || 0,
                  settledInvoiceAmount: _.settled_amount,
                  transactionId: _.transaction_id,
                  transactionType: _.transaction_type,
                  voucherNumber: _.voucher_number,
                  voucherType: _.voucher_type,
                }
              }),
            message: [],
            nextAdvanceNumber: null,
            referenceAmount: i === 0 ? 0 : tr.transactionAmount,
            setOffInvoiceParentLedger: tr.parentLedger,
            setOffInvoiceSubLedger: null,
            showOptions: i === 0 ? false : true,
            transactionType: i === 0 ? null : tr.transactionType,
          }
        })
      }
      setTransactionDetails({
        data: otherVouchersData,
        transactionDetails: {
          companyId: company.value,
          exchangeMultiplier: transaction.exchangeMultiplier,
          fyName: financialYear.value,
          narration: '',
          reportingCurrency: transaction.reportingCurrency,
          totalAmount: transaction.totalAmount,
          transactingCurrency: transaction.transactingCurrency,
          transactionDetails: transactionDetails,
          voucherDate: transaction.voucherDate,
          voucherName: transaction.voucherName,
          voucherNumber: transaction.voucherNumber,
          voucherType: transaction.voucherType,
        },
      })

      setStatus(true)
    }
  }, [location.state])

  useEffect(() => {
    if (!location.state) {
      setInvoiceDetails([])
    }
  }, [location.state, activeTab])
  // console.log(ledgerMapping)

  const getExchangeRates = async () => {
    if (company?.value && financialYear?.value) {
      const res = await getExchangeRate(
        company.value,
        financialYear.value,
        voucherDate,
        currency?.value || ''
      )
      res && setExchangeRate({exchangeRate: res?.exchangeRate, asOnDate: res?.asOnDate})
      res && setApplicableRate(res?.exchangeRate)
    }
  }
  useEffect(() => {
    if (currency?.value && reportingCurrency && currency?.value !== reportingCurrency) {
      getExchangeRates()
      setCurrencyModal(true)
    }
  }, [company?.value, currency, financialYear?.value, reportingCurrency, voucherDate])

  const fetchAccountingDetails = useCallback(async () => {
    setError(false)
    setLoading(true)
    try {
      const res = await getAccountingDetails(company?.value, financialYear?.value)
      // console.log(res)
      if (!res)
        throw new Error('Loading ledger data encountered an error. Please try refreshing the page.')
      if (res?.voucherTypeMap[activeTab]) {
        const voucherOption = res?.voucherTypeMap[activeTab].map((opt) => ({
          label: opt,
          value: opt === 'None' ? null : opt,
        }))
        setVoucherOptions(voucherOption)
      }

      res?.byLedger[activeTab === 'purchase' ? 'purchases' : activeTab] &&
        setByLedgerDetails(res?.byLedger[activeTab === 'purchase' ? 'purchases' : activeTab])

      res?.toLedger[activeTab === 'purchase' ? 'purchases' : activeTab] &&
        setToLedgerDetails(res?.toLedger[activeTab === 'purchase' ? 'purchases' : activeTab])

      res?.ledgerCurrentBalanceMapping &&
        setLedgerCurrentBalanceMapping(res?.ledgerCurrentBalanceMapping)

      res?.ledgerMapping && setLedgerMapping(res?.ledgerMapping)

      res?.voucherMapping && setVoucherMapping(res?.voucherMapping)
      res?.voucherNumberMapping && setVoucherNumberMapping(res?.voucherNumberMapping)
      if (res?.voucherCurrency) {
        const currencyOption = res?.voucherCurrency.map((opt) => ({label: opt, value: opt}))
        // console.log(res?.voucherCurrency)
        setCurrencyOptions(currencyOption)
      }
      if (res?.reportingCurrency) {
        setReportingCurrency(res?.reportingCurrency)
        !location.state &&
          setCurrency({label: res?.reportingCurrency, value: res?.reportingCurrency})
        setPrevCurrency({label: res?.reportingCurrency, value: res?.reportingCurrency})
      }
      setLastCompanyId(company.value)
    } catch (err: any) {
      err &&
        toast.error('Loading ledger data encountered an error. Please try refreshing the page.')
      setError(true)
    } finally {
      setLoading(false)
      // setShouldRefreshLedgers(false)
      // setCompleted(false)
    }
  }, [company, financialYear, activeTab, location.state])

  useEffect(() => {
    if (financialYear.value && shouldRefreshLedgers && !status) {
      fetchAccountingDetails()
    }
  }, [shouldRefreshLedgers, fetchAccountingDetails, financialYear, status])
  // Separate effect to handle company changes
  useEffect(() => {
    if (company?.value && company.value !== lastCompanyId && financialYear.value) {
      fetchAccountingDetails()
    }
  }, [company?.value, financialYear?.value, fetchAccountingDetails, lastCompanyId])

  const handleCreateTransaction = async () => {
    // console.log(currency)
    if (company?.value && financialYear?.value && currency?.value) {
      setLoading(true)

      const newBody: CreateTransactionBody = {
        transaction: {
          company_id: Number(company?.value),
          fy_name: financialYear?.value,
          voucher_id:
            voucherMapping?.[activeTab]?.voucherName?.value ||
            voucherMapping?.[activeTab]?.['None'],
          // voucherType: activeTab,
          // voucherName: voucherName?.value == null ? '' : voucherName?.value,
          voucher_number: voucherNumberMapping?.[activeTab],
          currency_code: currency.value,
          // voucher_number: 0,
          // transactingCurrency: currency?.value,
          reporting_currency: reportingCurrency,
          voucher_date: voucherDate,
          total_amount: 1.0,
          exchange_multiplier: 0.0,
          update_exchange_rate: updateExchangeRate,
          narration: narration || null,
          transaction_item: data.map((_: any) => ({
            transaction_type: _.transactionType,
            ledger_id: ledgerMapping?.[_.parentLedger]?.[_.subLedger || 'None'],
            transaction_amount: _.amount || null,
          })),
          is_na_reference: false,
          na_reference_amount: 0,
        },

        create_reference: transactionDetails.map((v: any, index: any) => ({
          show_options: v.showOptions,

          ...(v.showOptions && {
            transaction_item_id: v.transactionItemId,
            transaction_id: v.transactionId,
            ledger_id: v.ledgerId,
            ledger_code: v.ledgerCode,
            parent_ledger: v.parentLedger,
            sub_ledger: v.subLedger,
            transaction_type: v.transactionType,
            transaction_amount: v.transactionAmount,
            invoice_number: v.invoiceNumber ? String(v.invoiceNumber) : null,
            invoice_item:
              multiSetOffData === 'sales'
                ? {
                    invoice_number: String(v.invoiceNumber),
                    invoice_date: voucherDate,
                    due_date: invoiceDueDate,
                    amount: isArray(invoiceAmount) ? 0 : invoiceAmount,
                    transaction_type: v?.invoiceItem?.transactionType || v?.transactionType,
                    description: invoiceRemark || v?.invoiceItem?.description || '',
                  }
                : null,
            against_advance:
              multiSetOffData === 'sales'
                ? v.againstAdvance.map((ad: any) => ({
                    advance_id: ad.advanceId,
                    advance_number: ad.advanceNumber,
                    advance_date: ad.advanceDate,
                    amount: ad.amount,
                    transaction_type: ad.transactionType,
                    settled_amount: ad.settledAmount,
                    set_off_amount: ad.setOffAmount,
                    voucher_type: ad.voucherType,
                    voucher_number: ad.voucherNumber,
                    description: ad.description,
                  }))
                : null,
            advance_number: v.advanceNumber ? String(v.advanceNumber) : null,
            against_invoice:
              multiSetOffData === 'sales'
                ? null
                : v?.againstInvoice?.map((inv: any) => ({
                    invoice_id: inv.invoiceId,
                    invoice_number: inv.invoiceNumber,
                    invoice_date: inv.invoiceDate,
                    due_date: inv.dueDate,
                    amount: inv.amount,
                    transaction_type: inv.transactionType || v.transactionType,
                    settled_amount: inv.settledAmount,
                    set_off_amount: inv.setOffAmount,
                    voucher_type: inv.voucherType,
                    voucher_number: inv.voucherNumber,
                    description: inv.description,
                  })) || null,
            advance_item:
              multiSetOffData === 'sales'
                ? null
                : v.advanceNumber
                ? {
                    advance_number: String(v.advanceNumber) || null,
                    advance_date: v?.advanceItem?.advanceDate || voucherDate,
                    amount: v?.advanceItem?.amount || 0,
                    transaction_type: v?.advanceItem?.transactionType || v?.transactionType,
                    description: v?.advanceItem?.description || null,
                  }
                : null,
          }),
          is_na_reference: v.showOptions
            ? multiSetOffData === 'sales'
              ? isNaReferenceAmount(
                  v.transactionAmount,
                  invoiceAmount,
                  v?.againstAdvance.reduce((acc: any, adv: any) => acc + (adv.setOffAmount || 0), 0)
                )
              : isNaReferenceAmount(
                  v?.transactionAmount,
                  invoiceAmount[index],
                  againstInvoiceAmount[index]
                )
            : v.isNaReference,
          na_reference_amount:
            multiSetOffData === 'sales'
              ? v.transactionAmount -
                invoiceAmount -
                v?.againstAdvance.reduce((acc: any, adv: any) => acc + (adv.setOffAmount || 0), 0)
              : v?.transactionAmount - invoiceAmount[index] - againstInvoiceAmount[index],
          message: v.message,
        })),
      }
      // console.log(newBody)
      // return
      await createTransaction(newBody)
        .then((res) => {
          // console.log(res)
          if (res?.detail) {
            toast.success(res?.detail)
            setVoucherDate(new Date().toISOString().split('T')[0])
            setData(initialData)
            setNarration('')
            setStatus(false)
          }
        })
        .catch((err) => {
          toast.error(err.message || 'Some error occurred. Please try again.')
        })
        .finally(() => setLoading(false))
    }
  }
  // console.log(data)
  // console.log(activeTab)

const handleCreateNewTransaction = async () => {
      if (isInventoryItem) {
        try {
          setLoading(true);
          if (activeTab === 'purchase' || activeTab === 'creditnote') {
            console.log("Saving STOCK-IN data to backend:", stockInData);
          } else if (activeTab === 'sales' || activeTab === 'debitnote') {
            console.log("Saving STOCK-OUT data to backend:", stockOutData);
          }

          const voucher_id =
            voucherMapping?.[activeTab]?.voucherName?.value || voucherMapping?.[activeTab]?.['None'];
          if (!voucher_id) {
            throw new Error('Some error occurred. Please try again.');
          }
          if (company?.value && financialYear?.value && currency?.value) {
            const body: CreateReferenceBody = {
              company_id: Number(company?.value),
              fy_name: financialYear?.value,
              voucher_id,
              currency_code: currency.value,
              voucher_number: voucherNumberMapping?.[activeTab],
              reporting_currency: reportingCurrency,
              voucher_date: voucherDate,
              total_amount: creditTotal,
              exchange_multiplier: 0.0,
              update_exchange_rate: updateExchangeRate,
              narration: narration || null,
              transaction_item: data.map((_: any) => ({
                transaction_type: _.transactionType,
                ledger_id: ledgerMapping?.[_.parentLedger]?.[_.subLedger || 'None'],
                transaction_amount: _.amount,
              })),
              is_na_reference: false,
              na_reference_amount: 0,
            };
            const res = await createNewTransaction(body);
            if (res) {
              setStatus(true);
              setTransactionDetails(res);
              setInvoiceDescription('');
              setNarration('');
              setSetOffDone(false);
              toast.success("Voucher and inventory saved successfully!");
            } else {
              throw new Error('Failed to create the financial transaction.');
            }
          }
        } catch (err: any) {
          toast.error(err.message || 'An error occurred during the save process.');
        } finally {
          setLoading(false);
        }
      } else {
        const voucher_id =
          voucherMapping?.[activeTab]?.voucherName?.value || voucherMapping?.[activeTab]?.['None'];
        if (!voucher_id) {
          toast.error('Some error occurred. Please try again.');
          return;
        }
        if (company?.value && financialYear?.value && currency?.value) {
          setLoading(true);
          const body: CreateReferenceBody = {
            company_id: Number(company?.value),
            fy_name: financialYear?.value,
            voucher_id,
            currency_code: currency.value,
            voucher_number: voucherNumberMapping?.[activeTab],
            reporting_currency: reportingCurrency,
            voucher_date: voucherDate,
            total_amount: creditTotal,
            exchange_multiplier: 0.0,
            update_exchange_rate: updateExchangeRate,
            narration: narration || null,
            transaction_item: data.map((_: any) => ({
              transaction_type: _.transactionType,
              ledger_id: ledgerMapping?.[_.parentLedger]?.[_.subLedger || 'None'],
              transaction_amount: _.amount,
            })),
            is_na_reference: false,
            na_reference_amount: 0,
          };
          await createNewTransaction(body)
            .then((res) => {
              if (res) {
                setStatus(true);
                setTransactionDetails(res);
                setInvoiceDescription('');
                setNarration('');
                setSetOffDone(false);
              }
            })
            .catch((err) => {
              toast.error(err.message || 'Some error occurred. Please try again.');
            })
            .finally(() => setLoading(false));
        }
      }
    };

  const handleSetOffLogic = () => {
    setSetOffDone(true)
    setSetOffModal(false)
  }
  const [transactionDetails, setTransactionDetails]: any = useState()

  // Add state for Invoice Due Days
  const [invoiceDueDays, setInvoiceDueDays]: any = useState(30)
  const [invoiceDueDate, setInvoiceDueDate]: any = useState('')
  const [invoiceAmount, setInvoiceAmount]: any = useState([])
  const [newInvoiceNumber, setNewInvoiceNumber]: any = useState()
  const [invoiceRemark, setInvoiceRemark]: any = useState('')
  const [againstInvoiceAmount, setAgainstInvoiceAmount]: any = useState([])
  // console.log(invoiceAmount)
  // console.log(againstInvoiceAmount)
  const handleInvoiceInputChange = (
    e: any,
    index: number,
    field: string,
    indexParent: number,
    type: string
  ) => {
    // console.log('Amount  ', e)
    // console.log('index  ', index)
    // console.log('Field  ', field)
    // console.log('indexParent  ', indexParent)
    // console.log('type  ', type)
    if (type === 'againstInvoice') {
      const updatedTransactionDetails: any = [...transactionDetails]
      updatedTransactionDetails[indexParent].againstInvoice[index][field] = e
      setTransactionDetails([...updatedTransactionDetails])
    } else {
      const updatedTransactionDetails: any = [...transactionDetails]
      updatedTransactionDetails[indexParent].againstAdvanceDetails[index][field] = e
      setTransactionDetails(updatedTransactionDetails)
    }
  }
  useEffect(() => {
    setNewInvoiceNumber(transactionDetails?.[0]?.invoiceNumber)
  }, [transactionDetails])

  // Set default values when the component initializes
  useEffect(() => {
    const updatedInvoiceDueDate = updateDueDateFromDays(invoiceDueDays)
    const updatedInvoiceDueDate2 = moment().add(invoiceDueDays, 'days').format('YYYY-MM-DD')

    setInvoiceDueDate(updatedInvoiceDueDate)
    // Calculate the difference between the new due date and today to update Invoice Due Days
    // const today: any = new Date()
    // const dueDate: any = transactionDetails?.[1]?.newInvoice?.[0]?.dueDate
    // const newDueDateObject: any = new Date(dueDate)
    // const differenceInDays = Math.floor((newDueDateObject - today) / (24 * 60 * 60 * 1000))
    // // Set default values
    // setInvoiceDueDays(30) // Default Invoice Due Days is set to 7
  }, [voucherDate]) // Empty dependency array ensures this effect runs only once during component mount

  useEffect(() => {
    const checkDuplicate = hasDuplicateTransactionType(data, ledgerMapping)
    setNextDisabled(checkDuplicate)
  }, [data, ledgerMapping])

  const handleDueDaysChange = (newDueDays: any) => {
    const updatedInvoiceDueDate = moment(voucherDate).add(newDueDays, 'days').format('YYYY-MM-DD')

    setInvoiceDueDate(updatedInvoiceDueDate)
    // setInvoiceDueDays(newDueDays)
    // const newDueDate = updateDueDateFromDays(newDueDays)
    // // Get the relevant invoice details
    // const updatedTransactionDetails: any = [...transactionDetails]
    // const invoiceIndex = 0 // Adjust this index based on your data structure
    // const invoice = updatedTransactionDetails?.[1]?.newInvoice?.[0]

    // // Update the due date of the invoice
    // if (invoice) {
    //   const newDueDate = updateDueDateFromDays(newDueDays)
    //   invoice.dueDate = newDueDate

    //   // Update the state with the modified transaction details
    //   setTransactionDetails(updatedTransactionDetails)
    // }
  }
  const updateDueDateFromDays = (days: any) => {
    setIsValidDate(true)
    const today = new Date(voucherDate)
    if (isNaN(today.getTime())) {
      // Handle invalid date error
      setIsValidDate(false)
      toast.error('Invalid voucher date')
      return ''
    }
    const newDueDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1000)
    if (isNaN(newDueDate.getTime())) {
      // Handle invalid date error
      setIsValidDate(false)
      toast.error('Invalid due date')
      return ''
    }

    return newDueDate.toISOString().split('T')[0] // Format as 'YYYY-MM-DD'
  }

  const handleAdvanceDetailsChange = (index: any, fieldName: any, value: any) => {
    // console.log(transactionDetails)
    // Make a shallow copy of the data array from transactionDetails
    const updatedData = [...transactionDetails]

    const updatedAgainstAdvanceDetails = {...updatedData[index]?.advanceItem}

    updatedAgainstAdvanceDetails[fieldName] = value

    updatedData[index].advanceItem = updatedAgainstAdvanceDetails

    setTransactionDetails([...updatedData])
  }

  const multiSetOffData =
    transactionDetails && transactionDetails?.[0]['invoiceNumber']
      ? 'sales'
      : transactionDetails?.[0]['advanceNumber']
      ? 'other'
      : null
  // console.log(multiSetOffData)
  const handleAgainstAdvanceChange = (
    index: any,
    advanceIndex: any,
    fieldName: any,
    value: any
  ) => {
    // console.log(transactionDetails)
    // console.log('value ', value)
    // Make a shallow copy of the data array from transactionDetails
    const updatedData = [...transactionDetails]

    const updatedAgainstAdvanceDetails = {...updatedData[index]} // transaction only, go deeper to get againsadvance

    updatedAgainstAdvanceDetails.againstAdvance[advanceIndex][fieldName] = Number(value)

    updatedData[index].againstAdvance[advanceIndex] =
      updatedAgainstAdvanceDetails.againstAdvance[advanceIndex]

    setTransactionDetails([...updatedData])
  }
  const salesAndPurchaseView = () => {
    // const sumInvoiceAmount = sum(invoiceAmount)
    // const validateInvoiceAmount = isArray(invoiceAmount) ? sumInvoiceAmount : invoiceAmount
    // const validateInvoiceAmount = isArray(invoiceAmount) ? sumInvoiceAmount : invoiceAmount
    // console.log(map(get(transactionDetails, 'againstAdvance', []), 'againstInvoiceDetails'))
    const againstInvoiceTotalValue = transactionDetails?.[0]?.againstAdvance.reduce(
      (acc: any, v: any) => acc + (v.setOffAmount || 0),
      0
    )
    // console.log('sales and purchase')
    return (
      <>
        <div className='table-responsive'>
          <table
            id='view_transactions_table'
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          >
            <thead>
              <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                {/* <th>Voucher Number</th> */}
                <th>Voucher Id</th>
                <th>Voucher Name</th>
                <th>Voucher Date</th>
                <th>Transacting currency</th>
                {/* <th className='w-300px'>Total Amount</th> */}
                <th>NARRATIon</th>
              </tr>
            </thead>
            <tbody className='text-gray-600 fw-bold text-center'>
              <tr className='text-center'>
                {/* <td>{voucherNumber}</td> */}
                <td>
                  {voucherMapping?.[activeTab]?.voucherName?.value ||
                    voucherMapping?.[activeTab]?.['None']}
                </td>
                <td className='text-capitalize'>
                  {voucherName?.value
                    ? location?.pathname.split('/')[3] + ' - ' + voucherName.value
                    : location?.pathname.split('/')[3]}
                </td>
                <td>{voucherDate}</td>
                <td>
                  <span className='badge badge-primary'>{currency?.value}</span>
                </td>
                {/* <td>{creditTotal}</td> */}
                <td>{narration ? narration : '-'}</td>
              </tr>
              {data?.map((tableData: any, index: any) => (
                <tr className='text-center'>
                  <td colSpan={6}>
                    {' '}
                    <span className='fw-bolder text-dark'>{tableData?.parentLedger}</span> -{' '}
                    {tableData?.subLedger}
                    <span
                      className={`${
                        tableData?.transactionType === 'debit' ? 'text-danger' : 'text-success'
                      }`}
                      style={{fontStyle: 'italic'}}
                    >
                      {tableData?.amount}
                      {tableData?.transactionType === 'credit' ? ' CR' : ' DR'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {transactionDetails?.map((tr: any, index: any) => (
          <>
            {tr.showOptions && (
              <>
                <div className='d-flex align-items-center justify-content-between'>
                  <div className='text-end mb-5 d-flex w-100 align-items-center gap-2'>
                    <h6>Invoice Due Days</h6>
                    <input
                      type='text'
                      className='form-control w-75px'
                      value={invoiceDueDays}
                      onChange={(e: any) => {
                        setInvoiceDueDays(e.target.value)
                        handleDueDaysChange(Number(e.target.value))
                      }}
                    />
                  </div>
                  <div className='text-end mb-5 d-flex w-100 align-items-end justify-content-end'>
                    <div className='bg-light-primary text-center border d-flex flex-column border-dashed border-primary py-2 px-2 rounded'>
                      <div className='m-0 fs-7'>{currency?.value || 'USD'}</div>
                      <h3 className='m-0'>
                        {tr?.transactionAmount - (invoiceAmount || 0) - againstInvoiceTotalValue}
                        {/* {tr?.transactionAmount - invoiceAmount - againstInvoiceTotalValue} */}
                      </h3>
                      <div className='m-0 fs-7'>Available Set Off Amount</div>
                    </div>
                  </div>
                </div>
                <div className='table-responsive'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <h3>New Invoice</h3>
                    <h4 className='fw-bolder '>
                      <span>
                        {currency?.value} {invoiceAmount}
                      </span>
                    </h4>
                  </div>
                  <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                    <thead>
                      <tr className='text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0 text-center'>
                        <th className='col-lg-2 '>Invoice Number</th>
                        <th className='col-lg-2 '>Due Date</th>
                        <th className='col-lg-2 '>Amount</th>
                        <th className='col-lg-2 '>Type</th>
                        <th className='col-lg-4 '>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input
                            type='text'
                            name='invoiceNumber'
                            className='form-control'
                            defaultValue={newInvoiceNumber}
                            disabled={true}
                            onChange={(e) => {
                              setNewInvoiceNumber(e.target.value)
                              // handleInvoiceInputChange(
                              //   Number(e.target.value),
                              //   0,
                              //   'invoiceNumber',
                              //   0,
                              //   'newInvoice'
                              // )
                            }}
                            id=''
                          />
                        </td>
                        <td>
                          <input
                            type='date'
                            name='dueDate'
                            className='form-control'
                            value={invoiceDueDate}
                            onChange={(e) => {
                              const date1 = moment(voucherDate)
                              const date2 = moment(e.target.value).format('YYYY-MM-DD')
                              const days = date1.diff(date2, 'days')

                              if (days < 0) {
                                setInvoiceDueDays(Math.abs(days))
                                setInvoiceDueDate(date2)
                              }

                              // const diffTime = Math.abs(date2 - date1)
                              // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                              // const updatedInvoiceDueDate = updateDueDateFromDays(e.target.value)
                              // setInvoiceDueDate(updatedInvoiceDueDate)
                              // handleInvoiceInputChange(
                              //   e.target.value,
                              //   0,
                              //   'dueDate',
                              //   0,
                              //   'newInvoice'
                              // )
                              // // Calculate the difference between the new due date and today to update Invoice Due Days
                              // const today: any = new Date()
                              // const newDueDateObject: any = new Date()
                              // const differenceInDays = Math.floor(
                              //   (newDueDateObject - today) / (24 * 60 * 60 * 1000)
                              // )
                              // setInvoiceDueDays(differenceInDays)
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type='text'
                            name='amount'
                            className='form-control'
                            value={invoiceAmount}
                            onChange={(e) => {
                              const enteredAmount = Number(e.target.value)
                              const maxAmount = transactionDetails?.referenceAmount

                              const canEnterValue =
                                tr?.transactionAmount -
                                  (tr?.againstAdvance.reduce(
                                    (acc: any, v: any) => v.setOffAmount || 0 + acc,
                                    0
                                  ) +
                                    enteredAmount) >=
                                0
                              // Check if enteredAmount is less than or equal to maxAmount
                              if (canEnterValue) {
                                setInvoiceAmount(enteredAmount)

                                // Continue with additional logic if needed
                                // handleInvoiceInputChange(
                                //   Number(e.target.value),
                                //   0,
                                //   'amount',
                                //   0,
                                //   'newInvoice'
                                // );
                              } else {
                                // Optionally, you can show an error message or handle the validation failure in some way
                                // console.error('Entered amount exceeds the maximum allowed amount')
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Oops...',
                                  text: 'Entered amount exceeds the maximum allowed amount!',
                                  toast: true,
                                  position: 'top-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                })
                              }
                            }}
                            id=''
                          />
                        </td>
                        <td className='text-center'>
                          <span className='badge badge-secondary center'>
                            {tr?.transactionType}
                          </span>
                        </td>
                        <td>
                          <textarea
                            name='remark'
                            className='form-control'
                            value={invoiceRemark}
                            onChange={(e) => {
                              setInvoiceRemark(e.target.value)
                              // handleInvoiceInputChange(
                              //   e.target.value,
                              //   0,
                              //   'remarks',
                              //   0,
                              //   'newInvoice'
                              // )
                            }}
                            rows={3}
                          ></textarea>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {tr?.againstAdvance && tr?.againstAdvance.length > 0 && (
                  <div className='table-responsive'>
                    <div className='d-flex justify-content-between align-items-center'>
                      <h3>Against Advance</h3>
                      <h4 className='fw-bolder '>
                        <span>
                          {currency?.value} {againstInvoiceAmount}
                        </span>
                      </h4>
                    </div>
                    <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                      <thead>
                        <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                          <th className='col-1.5'>Reference Number</th>
                          <th className='col-1.5'>Date of advance</th>
                          <th className='col-1.5'>Amount</th>
                          <th className='col-1.5'>SETTLED AMOUNT</th>
                          <th className='col-1.5'> SET OFF AMOUNT </th>
                          <th className='col-1.5'>Type</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tr?.againstAdvance?.map((invoice: any, advIndex: number) => {
                          return (
                            <tr>
                              <td>
                                <input
                                  type='text'
                                  name='advanceNumber'
                                  disabled={true}
                                  className='form-control'
                                  value={invoice?.advanceNumber}
                                  onChange={(e) =>
                                    handleAgainstAdvanceChange(
                                      index,
                                      advIndex,
                                      'advanceNumber',
                                      e.target.value
                                    )
                                  }
                                  id=''
                                />
                              </td>
                              <td>
                                <input
                                  type='date'
                                  name='dateOfAdvance'
                                  disabled={true}
                                  className='form-control'
                                  value={invoice?.advanceDate}
                                  onChange={(e) =>
                                    handleAgainstAdvanceChange(
                                      index,
                                      advIndex,
                                      'advanceDate',
                                      e.target.value
                                    )
                                  }
                                  id=''
                                />
                              </td>
                              <td>
                                {' '}
                                <input
                                  type='number'
                                  name='amount'
                                  disabled={true}
                                  className='form-control'
                                  value={invoice?.amount}
                                  onChange={(e) => {
                                    const value = Number(e.target.value)
                                    setAgainstInvoiceAmount(value)
                                  }}
                                  id=''
                                />
                              </td>
                              <td>
                                {' '}
                                <input
                                  type='number'
                                  name='settledInvoiceAmount'
                                  disabled={true}
                                  className='form-control'
                                  value={invoice?.settledAmount}
                                  onChange={(e) => {
                                    const value = Number(e.target.value)
                                    setAgainstInvoiceAmount(value)
                                  }}
                                  id=''
                                />
                              </td>
                              <td>
                                {' '}
                                <input
                                  type='number'
                                  name='setOff'
                                  className='form-control'
                                  value={invoice?.setOffAmount}
                                  onChange={(e) => {
                                    // const canEnterValue =
                                    //   tr?.transactionAmount - (sumAgainstInvoiceAmount + enteredAmount) >=
                                    //   0
                                    const enteredAmount = Number(e.target.value)
                                    const canEnterValue =
                                      tr?.transactionAmount -
                                        (tr?.againstAdvance
                                          ?.filter((v: any, i: number) => i !== advIndex)
                                          .reduce(
                                            (acc: any, v: any) => v?.setOffAmount || 0 + acc,
                                            0
                                          ) +
                                          enteredAmount) >=
                                        0 && invoice.amount - invoice.settledAmount >= enteredAmount
                                    if (canEnterValue) {
                                      handleAgainstAdvanceChange(
                                        index,
                                        advIndex,
                                        'setOffAmount',
                                        e.target.value
                                      )
                                    } else {
                                      Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Entered amount exceeds the maximum allowed amount!',
                                        toast: true,
                                        position: 'top-end',
                                        showConfirmButton: false,
                                        timer: 3000,
                                      })
                                    }
                                  }}
                                  id=''
                                />
                              </td>

                              <td>
                                <span className='badge badge-secondary'>
                                  {invoice?.transactionType}
                                </span>
                              </td>
                              <td>
                                <textarea
                                  name='remark'
                                  className='form-control'
                                  value={invoice?.description}
                                  disabled={true}
                                  onChange={(e) =>
                                    handleAgainstAdvanceChange(
                                      index,
                                      advIndex,
                                      'description',
                                      e.target.value
                                    )
                                  }
                                  rows={3}
                                ></textarea>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
            {tr.message.map((msg: any) => (
              <div className='my-5 p-5  fw-bolder fs-5 bg-light-primary rounded  border border-dashed border-primary'>
                {msg.message}
              </div>
            ))}

            {tr.showOptions && (
              <div className='my-5 p-5  fw-bolder fs-5 bg-light-primary rounded  border border-dashed border-primary text-start'>
                The set-off amount{' '}
                {tr?.transactionAmount - invoiceAmount - againstInvoiceTotalValue} will be marked
                under no reference.{' '}
              </div>
            )}
          </>
        ))}

        {/* <div className='card-footer text-end px-0'>
          <button
            className='btn btn-primary me-5'
            disabled={transactionDetails?.length > 0 ? false : true}
            onClick={() => {
              handleCreateTransaction()
            }}
          >
            Save
          </button>
          <button
            className='btn btn-danger'
            onClick={() => {
              setModal(true)
              // navigate(previousPath)
            }}
          >
            Discard
          </button>
        </div> */}
        <ImageModal
          show={modal}
          onHide={() => {
            setModal(false)
            window.location.reload()
          }}
          falseStatus={() => {
            setStatus(false)
          }}
        />
      </>
    )
  }
  function totalCOunting() {
    if (multiSetOffData === 'other') {
      // console.log('totalcounting')
      let totalInvoiceAmount: any = []
      let totalAgainstAmount: any = []
      transactionDetails?.forEach((item: any) => {
        let itemTotalInvoiceAmount: any = 0
        // console.log(item.againstInvoiceDetails)
        item.againstInvoice.forEach((invoice: any, index: number) => {
          // if (index === 0) {
          //   itemTotalInvoiceAmount = invoice?.settledInvoiceAmount
          // } else itemTotalInvoiceAmount += invoice.settledInvoiceAmount
          itemTotalInvoiceAmount = itemTotalInvoiceAmount + (invoice.setOffAmount || 0)
        })

        totalInvoiceAmount.push(itemTotalInvoiceAmount)
        totalAgainstAmount.push(
          !item.advanceItem && !item?.advanceItem?.amount ? 0 : item?.advanceItem?.amount
        )
      })

      // Filter out undefined elements
      const filteredInvoiceAmount = totalInvoiceAmount.filter((amount: any) => amount !== undefined)
      const filteredAgainstAmount = totalAgainstAmount.filter((amount: any) => amount !== undefined)
      // console.log(totalAgainstAmount)
      // console.log(filteredInvoiceAmount)
      // console.log(filteredAgainstAmount)
      setInvoiceAmount(filteredInvoiceAmount)
      setAgainstInvoiceAmount(filteredAgainstAmount)
    }
    // if (multiSetOffData === 'sales') {
    //   let totalInvoiceAmount: any = []
    //   let totalAgainstAmount: any = []
    //   transactionDetails?.forEach((item: any) => {
    //     let itemTotalInvoiceAmount: any = 0
    //     //  // console.log(item.againstInvoiceDetails)
    //     item.againstAdvance.forEach((adv: any, index: number) => {
    //       // if (index === 0) {
    //       //   itemTotalInvoiceAmount = invoice?.settledInvoiceAmount
    //       // } else itemTotalInvoiceAmount += invoice.settledInvoiceAmount
    //       itemTotalInvoiceAmount = itemTotalInvoiceAmount + (adv.setOffAmount || 0)
    //     })

    //     totalInvoiceAmount.push(itemTotalInvoiceAmount)
    //     totalAgainstAmount.push(
    //       !item.invoiceItem && !item?.invoiceItem?.amount ? 0 : item?.invoiceItem?.amount
    //     )
    //   })

    //   // Filter out undefined elements
    //   const filteredInvoiceAmount = totalInvoiceAmount.filter((amount: any) => amount !== undefined)
    //   const filteredAgainstAmount = totalAgainstAmount.filter((amount: any) => amount !== undefined)
    //   // console.log(totalAgainstAmount)
    //   // console.log(filteredInvoiceAmount)
    //   // console.log(filteredAgainstAmount)
    //   setInvoiceAmount(filteredInvoiceAmount)
    //   setAgainstInvoiceAmount(filteredAgainstAmount)
    //   // setInvoiceAmount(transactionDetails?.[0]?.invoiceItem?.amount || 0)
    // }
  }

  // const validateOtherEnteredAmount = () => {
  //   const againstInvoiceTotalValue = sum(
  //     compact(
  //       map(
  //         flatten(map(get(transactionDetails, 'data', []), 'againstInvoiceDetails')),
  //         'settOffAmount'
  //       )
  //     )
  //   )
  //   const sumAgainstInvoiceAmount = sum(againstInvoiceAmount)

  // }
  useEffect(() => {
    totalCOunting()
  }, [transactionDetails])

  const otherVoucherView = () => {
    // console.log(transactionDetails)
    // console.log('other')
    transactionDetails
      ?.map((_: any) => _.againstAdvance)
      .reduce((acc: any, v: any) => acc + (v?.setOffAmount || 0), 0)
    const againstInvoiceTotalValue = sum(
      compact(
        map(
          flatten(map(get(transactionDetails, 'data', []), 'againstInvoiceDetails')),
          'settOffAmount'
        )
      )
    )
    // // console.log(againstInvoiceTotalValue)
    // const sumAgainstInvoiceAmount = sum(againstInvoiceAmount)

    return transactionDetails.map((item: any, index: number) => {
      // console.log(item)
      // console.log(item?.referenceAmount)
      const calculatedReferenceAmount =
        item?.transactionAmount - invoiceAmount[index] - againstInvoiceAmount[index]

      return (
        <>
          <div className='accordion' id={`accordionExample${index}`}>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='headingOne'>
                <button
                  className='accordion-button'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target={`#collapse${index}`}
                  aria-expanded='true'
                  aria-controls={`collapse${index}`}
                >
                  <div className='text-start text-muted fw-bolder bg-light ps-4 fs-5 text-uppercase gs-0'>
                    {item?.parentLedger}
                  </div>
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className='accordion-collapse collapse show'
                aria-labelledby='headingOne'
                data-bs-parent={`#accordionExample${index}`}
              >
                <div className='accordion-body'>
                  {item?.showOptions && (
                    <>
                      <div className='d-flex align-items-center justify-content-between'>
                        {/* <div className='text-end mb-5 d-flex w-100 align-items-center gap-2'>
                    <h6>Invoice Due Days</h6>
                    <input
                      type='text'
                      className='form-control w-75px'
                      value={invoiceDueDays}
                      onChange={(e: any) => {
                        setInvoiceDueDays(e.target.value)
                        handleDueDaysChange(Number(e.target.value))
                      }}
                    />
                  </div> */}
                        <div className='text-end mb-5 d-flex w-100 align-items-end justify-content-end'>
                          <div className='bg-light-primary text-center border d-flex flex-column border-dashed border-primary py-2 px-2 rounded'>
                            <div className='m-0 fs-7'>{currency?.value || 'USD'}</div>
                            {/* <h3 className='m-0'>{item?.referenceAmount}</h3> */}
                            <h3 className='m-0'>
                              {calculatedReferenceAmount ? calculatedReferenceAmount : 0}
                            </h3>
                            <div className='m-0 fs-7'>Pending Reference Amount</div>
                          </div>
                        </div>
                      </div>

                      <div className='table-responsive'>
                        <div className='d-flex justify-content-between align-items-center'>
                          <h3>New Advance</h3>
                          <h4 className='fw-bolder '>
                            <span>
                              {currency?.value} {againstInvoiceAmount[index]}
                            </span>
                          </h4>
                        </div>
                        <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                          <thead>
                            <tr className='text-start text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                              <th>Reference Number</th>
                              <th>Date of Advance</th>
                              <th>Amount</th>
                              <th>Type</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <input
                                  type='text'
                                  name='advanceNumber'
                                  // disabled={true}
                                  className='form-control'
                                  value={item?.advanceNumber}
                                  onChange={(e) =>
                                    handleAdvanceDetailsChange(
                                      index,
                                      'advanceNumber',
                                      e.target.value
                                    )
                                  }
                                  id=''
                                />
                              </td>
                              <td>
                                <input
                                  type='date'
                                  name='dateOfAdvance'
                                  disabled={true}
                                  className='form-control'
                                  value={voucherDate}
                                  onChange={(e) =>
                                    handleAdvanceDetailsChange(index, 'advanceDate', e.target.value)
                                  }
                                  id=''
                                />
                              </td>

                              <td>
                                <input
                                  type='number'
                                  name='amount'
                                  className='form-control'
                                  value={item?.advanceItem?.amount}
                                  defaultValue={0}
                                  onChange={(e) => {
                                    const enteredAmount = Number(e.target.value)
                                    const canEnterValue =
                                      item?.transactionAmount -
                                        (invoiceAmount[index] + enteredAmount) >=
                                      0

                                    // If the entered amount is less than or equal to the previous amount, update it
                                    if (canEnterValue) {
                                      handleAdvanceDetailsChange(index, 'amount', enteredAmount)
                                    } else {
                                      // Otherwise, check if the new amount exceeds the maximum allowed amount
                                      if (canEnterValue) {
                                        handleAdvanceDetailsChange(index, 'amount', enteredAmount)
                                      } else {
                                        totalCOunting()
                                        Swal.fire({
                                          icon: 'error',
                                          title: 'Oops...',
                                          text: 'Entered amount exceeds the maximum allowed amount!',
                                          toast: true,
                                          position: 'top-end',
                                          showConfirmButton: false,
                                          timer: 3000,
                                        })
                                      }
                                    }
                                  }}
                                  id=''
                                />
                              </td>

                              <td>
                                <span className='badge badge-secondary'>
                                  {item?.advanceItem?.transactionType || item.transactionType}
                                </span>
                              </td>
                              <td>
                                <textarea
                                  name='remark'
                                  className='form-control'
                                  value={item?.advanceItem?.description}
                                  onChange={(e) =>
                                    handleAdvanceDetailsChange(index, 'description', e.target.value)
                                  }
                                  rows={3}
                                ></textarea>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {item.againstInvoice && item.againstInvoice.length > 0 && (
                        <div className='table-responsive'>
                          <div className='d-flex justify-content-between align-items-center'>
                            <h3>Against Invoice</h3>
                            <h4 className='fw-bolder'>
                              <span>
                                {currency?.value} {invoiceAmount[index]}
                              </span>
                            </h4>
                          </div>
                          <table className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'>
                            <thead>
                              <tr className='text-start text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                                <th className='col-1.5'>Invoice Number</th>
                                <th className='col-1.5'>Date of Invoice</th>
                                <th className='col-1.5'>Amount</th>
                                <th className='col-1.5'>SETTLED AMOUNT</th>
                                <th className='col-1.5'> SET OFF </th>
                                <th className='col-1.5'>Type</th>
                                <th className='col-3'>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.againstInvoice?.map((invoice: any, invoiceIndex: number) => {
                                // console.log(invoice)
                                return (
                                  <tr>
                                    <td>
                                      <input
                                        type='text'
                                        name='invoiceNumber'
                                        // disabled={true}
                                        className='form-control'
                                        value={invoice?.invoiceNumber}
                                        onChange={(e) => {
                                          setNewInvoiceNumber(e.target.value)
                                          handleInvoiceInputChange(
                                            Number(e.target.value),
                                            invoiceIndex,
                                            'invoiceNumber',
                                            index,
                                            'againstInvoice'
                                          )
                                        }}
                                        id=''
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type='date'
                                        name='dueDate'
                                        className='form-control'
                                        value={invoice.invoiceDate}
                                        disabled={true}
                                        onChange={(e) => {
                                          const date1 = moment(voucherDate)
                                          const date2 = moment(e.target.value).format('YYYY-MM-DD')
                                          const days = date1.diff(date2, 'days')

                                          if (days < 0) {
                                            setInvoiceDueDays(Math.abs(days))
                                            setInvoiceDueDate(date2)
                                          }

                                          // const diffTime = Math.abs(date2 - date1)
                                          // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
                                          // const updatedInvoiceDueDate = updateDueDateFromDays(e.target.value)
                                          // setInvoiceDueDate(updatedInvoiceDueDate)
                                          handleInvoiceInputChange(
                                            moment(e.target.value).format('YYYY-MM-DD'),
                                            invoiceIndex,
                                            'invoiceDueDate',
                                            index,
                                            'againstInvoice'
                                          )
                                          // // Calculate the difference between the new due date and today to update Invoice Due Days
                                          // const today: any = new Date()
                                          // const newDueDateObject: any = new Date()
                                          // const differenceInDays = Math.floor(
                                          //   (newDueDateObject - today) / (24 * 60 * 60 * 1000)
                                          // )
                                          // setInvoiceDueDays(differenceInDays)
                                        }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type='text'
                                        disabled={true}
                                        name='amount'
                                        className='form-control'
                                        value={invoice?.amount}
                                        onChange={(e) => {
                                          const enteredAmount = Number(e.target.value)
                                          const maxAmount = item?.referenceAmount

                                          // Check if enteredAmount is less than or equal to maxAmount
                                          if (enteredAmount <= maxAmount) {
                                            // Continue with additional logic if needed
                                            handleInvoiceInputChange(
                                              enteredAmount,
                                              invoiceIndex,
                                              'amount',
                                              index,
                                              'againstInvoice'
                                            )
                                          } else {
                                            Swal.fire({
                                              icon: 'error',
                                              title: 'Oops...',
                                              text: 'Entered amount exceeds the maximum allowed amount!',
                                              toast: true,
                                              position: 'top-end',
                                              showConfirmButton: false,
                                              timer: 3000, // Adjust the timer as needed
                                            })
                                          }
                                        }}
                                        id=''
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type='text'
                                        disabled={true}
                                        name='amount'
                                        className='form-control'
                                        // value={get(
                                        //   invoice,
                                        //   'settledAmount',
                                        //   get(invoice, 'settledAdvanceAmount', 0)
                                        // )}
                                        value={invoice?.settledAmount}
                                        id=''
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type='number'
                                        name='setOff'
                                        className='form-control'
                                        value={invoice?.setOffAmount}
                                        onChange={(e) => {
                                          const enteredAmount = Number(e.target.value)
                                          const canEnterValue =
                                            item?.transactionAmount -
                                              (againstInvoiceAmount[index] + enteredAmount) >=
                                              0 &&
                                            invoice.amount - invoice.settledAmount >= enteredAmount
                                          if (canEnterValue) {
                                            // Allow if the entered amount decreases from the old value
                                            totalCOunting()
                                            handleInvoiceInputChange(
                                              enteredAmount,
                                              invoiceIndex,
                                              'setOffAmount',
                                              index,
                                              'againstInvoice'
                                            )
                                          } else {
                                            totalCOunting()
                                            Swal.fire({
                                              icon: 'error',
                                              title: 'Oops...',
                                              text: 'Entered amount exceeds the maximum allowed amount!',
                                            })
                                          }
                                        }}
                                        id=''
                                      />
                                    </td>
                                    <td>
                                      <span className='badge badge-secondary'>
                                        {invoice?.transactionType}
                                      </span>
                                    </td>
                                    <td>
                                      <textarea
                                        name='remark'
                                        className='form-control'
                                        disabled={true}
                                        value={invoice?.description}
                                        onChange={(e) => {
                                          setInvoiceRemark(e.target.value)
                                          handleInvoiceInputChange(
                                            e.target.value,
                                            invoiceIndex,
                                            'description',
                                            index,
                                            'againstInvoice'
                                          )
                                        }}
                                        rows={3}
                                      ></textarea>
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}

                  {item.message.map((msg: any) => (
                    <div className='my-5 p-5 fw-bolder fs-5 bg-light-primary rounded  border border-dashed border-primary'>
                      {msg?.message || null}
                    </div>
                  ))}
                  {item?.showOptions && (
                    <div className='my-5 p-5  fw-bolder fs-5 bg-light-primary rounded  border border-dashed border-primary'>
                      The set-off amount{' '}
                      {item?.transactionAmount -
                        invoiceAmount?.[index] -
                        againstInvoiceAmount?.[index]}{' '}
                      will be marked under no reference.{' '}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <ImageModal
            show={modal}
            onHide={() => {
              setModal(false)

              // window.location.reload()
            }}
            falseStatus={() => {
              setStatus(false)
              navigate('/transactions/enter/journal')
            }}
          />
        </>
      )
    })
  }
  // console.log(data)
  // console.log(transactionDetails)
  // if (loading || error) return <Preloader />
  // console.log(multiSetOffData)
  return (
    <>
      {status === false ? (
        <>
          <div className='card mb-5 mb-xl-10 transaction-card'>
            <div className='card-body border-bottom p-6'>
              <div className='d-flex flex-wrap align-items-center justify-content-between gap-5'>

                <div className='d-flex flex-wrap align-items-center gap-5'>
                  <div>
                    <Select
                      value={voucherName}
                      onChange={(option) => setVoucherName(option as OptionType)}
                      options={voucherOptions}
                      isSearchable={true}
                      styles={{
                        container: (baseStyles) => ({ ...baseStyles, minWidth: '180px' }),
                        singleValue: (styles) => ({ ...styles, color: 'black', fontWeight: 600 }),
                        placeholder: (styles) => ({ ...styles, color: 'black' }),
                      }}
                      components={{ IndicatorSeparator: () => null }}
                      placeholder='Voucher Name'
                    />
                  </div>

                  <div>
                    <input
                      type='date'
                      value={voucherDate}
                      onChange={(e) => setVoucherDate(e.target.value)}
                      className='form-control'
                      style={{ width: '150px' }}
                    />
                    {!isValidDate && (
                      <span style={{ color: 'red', fontSize: '12px' }}>Invalid date</span>
                    )}
                  </div>

                  <div>
                    <Select
                      value={currency}
                      onChange={(option) => {
                        setPrevCurrency(currency as OptionType)
                        setCurrency(option as OptionType)
                      }}
                      options={currencyOptions}
                      isSearchable={true}
                      styles={{
                        control: (base) => ({...base, minWidth: '100px'}),
                        singleValue: (styles) => ({ ...styles, color: 'black', fontWeight: 600 }),
                        placeholder: (styles) => ({ ...styles, color: 'black' }),
                      }}
                      components={{ IndicatorSeparator: () => null }}
                      placeholder='Currency (*)'
                      isDisabled={true}
                    />
                  </div>

                  {(activeTab === 'purchase' || activeTab === 'creditnote' || activeTab === 'sales' || activeTab === 'debitnote') && (
                    <div className='d-flex align-items-center gap-3 text-nowrap'>
                      <label className='form-check-label'>Is Inventory Item?</label>
                      <label className="quantum-switch">
                        <input
                          type="checkbox"
                          checked={isInventoryItem}
                          onChange={(e) => setIsInventoryItem(e.target.checked)}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  )}

                  {activeTab === 'journal' && (
                    <div className='d-flex align-items-center gap-3 text-nowrap'>
                      <label className='form-check-label'>Stock Adjustment?</label>
                      <label className="quantum-switch">
                        <input
                          type="checkbox"
                          checked={isStockAdjustment}
                          onChange={(e) => setIsStockAdjustment(e.target.checked)}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  )}
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <button
                    type='button'
                    className='btn p-0'
                    style={{
                      backgroundColor: 'var(--bs-primary)',
                      color: 'var(--bs-primary-inverse)',
                      display: 'inline-flex',
                      height: '38px',
                      alignItems: 'center',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                    onClick={() => navigate(`/transactions/view/${activeTab}`)}
                  >
                    <span className='px-5'>View Transactions</span>
                    <span
                      style={{
                        color: '#fff',
                        backgroundColor: '#006060',
                        padding: '0 15px',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        borderTopRightRadius: 'inherit',
                        borderBottomRightRadius: 'inherit',
                      }}
                    >
                      <KTIcon iconName='arrow-right' className='fs-2 text-white' />
                    </span>
                  </button>
                  <button
                    type='button'
                    className='btn p-0'
                    style={{
                      backgroundColor: 'var(--bs-primary)',
                      color: 'var(--bs-primary-inverse)',
                      display: 'inline-flex',
                      height: '38px',
                      alignItems: 'center',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                    onClick={() => setCreateLedger(true)}
                  >
                    <span className='px-5'>New Ledger</span>
                    <span
                      style={{
                        color: '#fff',
                        backgroundColor: '#006060',
                        padding: '0 15px',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        borderTopRightRadius: 'inherit',
                        borderBottomRightRadius: 'inherit',
                      }}
                    >
                      <KTIcon iconName='plus-circle' className='fs-2 text-white' />
                    </span>
                  </button>
                </div>
              </div>
            </div>

            {/* <div className='card-body border-bottom mx-3 px-6 py-3 text-start text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
              <div className='row'>
                <label className='col-lg-2 '></label>
                <label className='col-lg-5 '></label>
                <label className='col-lg-2 text-center'>DEBIT</label>
                <label className='col-lg-2 text-center'>CREDIT</label>
                <label className='col-lg-1'></label>
              </div>
            </div> */}

            <div className='card-body border-bottom p-3'>
              {data.map((d, i) => (
                <TransactionRow
                  key={i}
                  row={d}
                  index={i}
                  ledgerCurrentBalanceMapping={ledgerCurrentBalanceMapping}
                  data={data}
                  setData={setData}
                  byLedgerDetails={byLedgerDetails}
                  toLedgerDetails={toLedgerDetails}
                  showConversion={currency?.value !== reportingCurrency}
                  applicableRate={applicableRate}
                  reportingCurrency={reportingCurrency}
                />
              ))}

              <div className='row border-bottom pb-3'>
                <div className='col-lg-11'></div>
                <div className='col-lg-1 d-flex flex-center flex-column gap-5'>
                  <button
                    type='button'
                    data-bs-toggle='tooltip'
                    data-bs-trigger='hover'
                    data-bs-dismiss-='click'
                    title='Add'
                    className='btn btn-lg'
                    style={{
                      borderRadius: '1000%',
                      height: '30px',
                      width: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      backgroundColor: '#f0f0f0',
                    }}
                    onClick={() =>
                      setData((prev) => [
                        ...prev,
                        {transactionType: 'debit', parentLedger: '', subLedger: '', amount: 0},
                      ])
                    }
                  >
                    <KTIcon iconName='plus' className='fs-3 px-0' />
                  </button>
                </div>
              </div>

              <div className='row p-3'>
                <label className='col-lg-2 '></label>
                <label className='col-lg-5 '></label>
                <label className='col-lg-2'>
                  <CardsWidget7
                    className='border border-dashed border-gray-300'
                    stats={formatNumber(debitTotal)}
                    description='Total Debit'
                  />
                </label>
                <label className='col-lg-2'>
                  <CardsWidget7
                    className='border border-dashed border-gray-300'
                    stats={formatNumber(creditTotal)}
                    description='Total Credit'
                  />
                </label>
                <label className='col-lg-1'></label>
              </div>
            </div>
            {setOffDone && (
              <div className='px-6'>
                <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
                  <KTIcon iconName='design-frame' className='fs-2tx text-primary me-4' />
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <div className='fs-6 text-gray-600'>Set off has been applied.</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!loading && (
              <div className='card-body border-bottom p-6'>
                <textarea
                  className='form-control'
                  value={narration}
                  onChange={(e) => setNarration(e.target.value)}
                  placeholder='Narration'
                />
              </div>
            )}

            {isInventoryItem && (activeTab === 'purchase' || activeTab === 'creditnote' || activeTab === 'sales' || activeTab === 'debitnote') && (
                <div className='card-body border-top p-6'>
                  <h3 className='mb-5'>Inventory Details</h3>
                  
                  {(activeTab === 'purchase' || activeTab === 'creditnote') ? (
                    <div className='row g-5'>
                      <div className='col-md-4'>
                        <label className='form-label required'>Warehouse</label>
                        <select 
                          className='form-select' 
                          value={stockInData.warehouse} 
                          onChange={(e) => setStockInData({ ...stockInData, warehouse: e.target.value })}
                        >
                          <option value="" disabled>Select Warehouse...</option>
                          {/* Options will be populated from an API call */}
                        </select>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label required'>Product</label>
                        <select 
                          className='form-select' 
                          value={stockInData.product} 
                          onChange={(e) => setStockInData({ ...stockInData, product: e.target.value })}
                        >
                          <option value="" disabled>Select Product...</option>
                          {/* Options will be populated from an API call */}
                        </select>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label required'>Quantity</label>
                        <input type='number' className='form-control' value={stockInData.quantity <= 0 ? '' : stockInData.quantity} onChange={(e) => setStockInData({ ...stockInData, quantity: Number(e.target.value) })}/>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label'>Purchase Amount</label>
                        <input type='number' className='form-control' value={stockInData.purchaseAmount <= 0 ? '' : stockInData.purchaseAmount} onChange={(e) => setStockInData({ ...stockInData, purchaseAmount: Number(e.target.value) })}/>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label'>Inventory Valuation Per Unit</label>
                        <div className='form-control form-control-solid'>
                          {stockInData.quantity > 0
                            ? (stockInData.purchaseAmount / stockInData.quantity).toFixed(2)
                            : '0.00'}
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label required'>Source Type</label>
                        <select className='form-select' value={stockInData.sourceType} onChange={(e) => setStockInData({ ...stockInData, sourceType: e.target.value })}>
                          <option value="Purchase">Purchase</option>
                          <option value="Return">Return</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label required'>Reference Document No.</label>
                        <input type='text' className='form-control' value={stockInData.referenceDoc} onChange={(e) => setStockInData({ ...stockInData, referenceDoc: e.target.value })}/>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label required'>Date of Entry</label>
                        <input type='date' className='form-control' value={stockInData.dateOfEntry} onChange={(e) => setStockInData({ ...stockInData, dateOfEntry: e.target.value })}/>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label'>Batch No. / Expiry</label>
                        <input type='text' className='form-control' value={stockInData.batchNumber} onChange={(e) => setStockInData({ ...stockInData, batchNumber: e.target.value })}/>
                      </div>
                      <div className='col-md-4'>
                        <label className='form-label'>Upload Document</label>
                        <input 
                          type='file' 
                          className='form-control' 
                          onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                              setStockInData({ ...stockInData, uploadDocument: e.target.files[0] });
                            }
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className='row g-5'> 
                      <div className='col-md-4'>
                        <label className='form-label required'>Warehouse</label>
                        <select 
                          className='form-select' 
                          value={stockOutData.warehouse} 
                          onChange={(e) => setStockOutData({ ...stockOutData, warehouse: e.target.value })}
                        >
                          <option value="" disabled>Select Warehouse...</option>
                          {/* Options to be populated from API */}
                        </select>
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label required'>Product</label>
                        <select 
                          className='form-select' 
                          value={stockOutData.product} 
                          onChange={(e) => setStockOutData({ ...stockOutData, product: e.target.value })}
                        >
                          <option value="" disabled>Select Product...</option>
                          {/* Options to be populated from API */}
                        </select>
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label'>Available Stock</label>
                        <input 
                          type='text' 
                          className='form-control' 
                          placeholder='Auto-calculated' 
                          disabled 
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label required'>Quantity</label>
                        <input 
                          type='number' 
                          className='form-control' 
                          value={stockOutData.quantity <= 0 ? '' : stockOutData.quantity} 
                          onChange={(e) => setStockOutData({ ...stockOutData, quantity: Number(e.target.value) })}
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label required'>Destination</label>
                        <select 
                          className='form-select' 
                          value={stockOutData.destination} 
                          onChange={(e) => setStockOutData({ ...stockOutData, destination: e.target.value })}
                        >
                          <option value="" disabled>Select Destination...</option>
                          <option value="Sales">Sales</option>
                          <option value="Scrap">Scrap</option>
                        </select>
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label required'>Reference Document Number</label>
                        <input 
                          type='text' 
                          className='form-control' 
                          value={stockOutData.referenceDocNumber} 
                          onChange={(e) => setStockOutData({ ...stockOutData, referenceDocNumber: e.target.value })}
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label'>Upload Document</label>
                        <input 
                          type='file' 
                          className='form-control' 
                          onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                              setStockOutData({ ...stockOutData, uploadDocument: e.target.files[0] });
                            }
                          }}
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label'>Sale Amount</label>
                        <input 
                          type='number' 
                          className='form-control' 
                          value={stockOutData.saleAmount <= 0 ? '' : stockOutData.saleAmount} 
                          onChange={(e) => setStockOutData({ ...stockOutData, saleAmount: Number(e.target.value) })}
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label'>Inventory Valuation</label>
                        <input 
                          type='text' 
                          className='form-control' 
                          placeholder='Auto-calculated' 
                          disabled 
                        />
                      </div>

                      <div className='col-md-4'>
                        <label className='form-label'>Batch No. / Expiry</label>
                        <input 
                          type='text' 
                          className='form-control' 
                          value={stockOutData.batchExpiry} 
                          onChange={(e) => setStockOutData({ ...stockOutData, batchExpiry: e.target.value })}
                        />
                      </div>
                    </div>
                  )}
                </div>
            )}
            
            {isStockAdjustment && activeTab === 'journal' && (
              <div className='card-body border-top p-6'>
                <h3 className='mb-5'>Stock Adjustment Details</h3>
                <div className='row g-5'>

                 
                  <div className='col-md-4'>
                    <label className='form-label required'>Warehouse</label>
                    <select 
                      className='form-select' 
                      value={stockAdjustmentData.warehouse} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, warehouse: e.target.value })}
                    >
                      <option value="" disabled>Select Warehouse...</option>
                    </select>
                  </div>

                  <div className='col-md-4'>
                    <label className='form-label required'>Product</label>
                    <select 
                      className='form-select' 
                      value={stockAdjustmentData.product} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, product: e.target.value })}
                    >
                      <option value="" disabled>Select Product...</option>
                    </select>
                  </div>

                  <div className='col-md-4'>
                    <label className='form-label'>Available Stock</label>
                    <input type='text' className='form-control' placeholder='Auto-calculated' disabled />
                  </div>

                 
                  <div className='col-md-4'>
                    <label className='form-label required'>Adjustment Type</label>
                    <select 
                      className='form-select' 
                      value={stockAdjustmentData.adjustmentType} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, adjustmentType: e.target.value as 'Addition' | 'Reduction' })}
                    >
                      <option value="" disabled>Select Type...</option>
                      <option value="Addition">Addition</option>
                      <option value="Reduction">Reduction</option>
                    </select>
                  </div>

                  <div className='col-md-4'>
                    <label className='form-label required'>Quantity</label>
                    <input 
                      type='number' 
                      className='form-control' 
                      value={stockAdjustmentData.quantity <= 0 ? '' : stockAdjustmentData.quantity} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, quantity: Number(e.target.value) })}
                    />
                  </div>
                  
                  <div className='col-md-4'>
                    <label className='form-label'>Total Amount</label>
                    <input 
                      type='number' 
                      className='form-control' 
                      value={stockAdjustmentData.value <= 0 ? '' : stockAdjustmentData.value} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, value: Number(e.target.value) })}
                    />
                  </div>
                  
                 
                  <div className='col-md-4'>
                    <label className='form-label required'>Reason Code</label>
                    <select 
                      className='form-select' 
                      value={stockAdjustmentData.reasonCode} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, reasonCode: e.target.value })}
                    >
                      <option value="" disabled>Select Reason...</option>
                      <option value="Stock Shortage / Theft / Damage / Expiry">Stock Shortage / Theft / Damage / Expiry</option>
                      <option value="Internal Consumption / Free Samples / Marketing">Internal Consumption / Free Samples / Marketing</option>
                      <option value="Excess Stock Found">Excess Stock Found</option>
                      <option value="Production Wastage / Scrap">Production Wastage / Scrap</option>
                      <option value="Inventory Revaluation">Inventory Revaluation</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  
                  <div className='col-md-4'>
                    <label className='form-label required'>Approver</label>
                    <select 
                      className='form-select' 
                      value={stockAdjustmentData.approver} 
                      onChange={(e) => setStockAdjustmentData({ ...stockAdjustmentData, approver: e.target.value })}
                    >
                      <option value="" disabled>Select Approver...</option>
                      <option value="Admin User">Admin User</option>
                      <option value="Store Manager">Store Manager</option>
                      <option value="Supervisor">Supervisor</option>
                    </select>
                  </div>

                </div>
              </div>
            )}

            {!loading && (
              <div className='card-body d-flex flex-end flex-column p-6 me-4 gap-5'>
                {/* {errorMessage && <InfoAlert message={errorMessage} />} */}
                <button
                  type='button'
                  // className={`btn btn-primary d-flex align-items-center next-button`}
                  className='btn p-0'
                  style={{
                    backgroundColor: 'var(--bs-primary)',
                    color: 'var(--bs-primary-inverse)',
                    display: 'inline-flex',
                    height: '43.59px',
                    alignItems: 'center',
                    justifyContent: 'space-between',

                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                  disabled={
                    debitTotal !== creditTotal ||
                    !currency?.value ||
                    data.some((d) => !d.parentLedger || !d.amount) ||
                    nextDisabled
                  }
                  onClick={() => {
                    handleCreateNewTransaction()
                  }}
                >
                  {/* <span>{loading ? 'Saving...' : 'Next'}</span>
                  <KTIcon iconName='double-right' className={`fs-4 pe-0`} /> */}
                  <span className='px-5'>{loading ? 'Saving...' : 'Next'}</span>
                  <span
                    style={{
                      color: '#fff',
                      backgroundColor: '#006060',
                      padding: '0 15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                      borderTopRightRadius: 'inherit',
                      borderBottomRightRadius: 'inherit',
                    }}
                  >
                    <KTIcon iconName='double-right' className='fs-2 text-white' />
                  </span>
                </button>
              </div>
            )}
            {loading && <Loader isError={error} />}
          </div>
          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={createLedger}
            animation={true}
            size='xl'
            contentClassName='top-0'
          >
            <CreateEditLedger
              setCreateLedger={setCreateLedger}
              editLedger={editLedger}
              setEditLedger={setEditLedger}
              setShouldRefreshLedgers={setShouldRefreshLedgers}
            />
          </Modal>
          <Modal
            className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
            id='disable_financial_year'
            role='dialog'
            data-backdrop='false'
            aria-hidden='true'
            tabIndex='-1'
            show={currencyModal}
            animation={false}
          >
            <div className='modal-content'>
              <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fw-bold m-0'>Currency Exchange Rate</h5>
                <div className='d-flex ms-2'>
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={async () => {
                      setCurrencyModal(false)
                      setCurrency(prevCurrency as OptionType)
                      await getExchangeRates()
                    }}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                </div>
              </div>

              <div className='py-5 px-5'>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Reporting Currency:</label>

                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>{reportingCurrency}</span>
                  </div>
                </div>
                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Transaction Currency:</label>

                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>{currency?.value || ''}</span>
                  </div>
                </div>

                <div className='row mb-7'>
                  <label className='col-lg-4 fw-bold text-muted'>Fetched Rate:</label>

                  <div className='col-lg-8'>
                    <span className='fw-bolder fs-6 text-dark'>
                      {exchangeRate?.exchangeRate || 0} (as on {exchangeRate?.asOnDate})
                    </span>
                  </div>
                </div>

                <div className='row mb-7 d-flex align-items-center'>
                  <label className='col-lg-4 fw-bold text-muted'>Applicable Rate:</label>

                  <div className='col-lg-8'>
                    <input
                      type='number'
                      className='form-control'
                      value={applicableRate <= 0 ? '' : applicableRate}
                      placeholder='Applicable Rate'
                      onChange={(e) =>
                        Number(e.target.value) >= 0 && setApplicableRate(Number(e.target.value))
                      }
                    />
                  </div>
                </div>

                <div className='row mb-7'>
                  <input
                    className='col-lg-2'
                    type='checkbox'
                    checked={updateExchangeRate}
                    onChange={() => setUpdateExchangeRate((prev) => !prev)}
                  />
                  <label className='col-lg-10 fw-bolder fs-6 text-dark'>
                    Update this exchange rate in the system
                  </label>
                </div>
              </div>

              <div className='d-flex flex-end p-5'>
                <button
                  type='reset'
                  onClick={async () => {
                    setCurrency(prevCurrency as OptionType)
                    setCurrencyModal(false)
                    await getExchangeRates()
                  }}
                  className='btn btn-light me-3'
                  data-kt-users-modal-action='cancel'
                >
                  Cancel
                </button>

                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  onClick={() => setCurrencyModal(false)}
                >
                  Proceed
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            size='lg'
            className='modal-sticky modal-sticky-lg'
            data-backdrop='false'
            aria-hidden='true'
            show={setOffModal}
            animation={false}
          >
            <div className='modal-content='>
              {/*begin::Header*/}
              <div className='modal-header d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                <h5 className='fs-2 fw-bold m-0'>Set Off Invoices</h5>
                <div className='d-flex ms-2'>
                  {/*begin::Close*/}
                  <div
                    className='btn btn-icon btn-sm btn-light-primary ms-2'
                    data-bs-dismiss='modal'
                    onClick={() => setSetOffModal(false)}
                  >
                    <KTIcon className='fs-1' iconName='cross' />
                  </div>
                  {/*end::Close*/}
                </div>
              </div>
              {/*end::Header*/}

              <div className='modal-body'>
                {invoiceDetails?.length ? (
                  <div className='flex-row-fluid'>
                    <div className='row mb-2 border-bottom p-1'>
                      <div className='col-lg-3 text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                        Invoice Number
                      </div>
                      <div className='col-lg-3 text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                        Invoice Amount
                      </div>
                      <div className='col-lg-3 text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                        Settled Amount
                      </div>
                      <div className='col-lg-3 text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                        Set Off Amount
                      </div>
                    </div>
                    {invoiceDetails?.map((invoice, index) => (
                      <div className='row mb-9 pb-3 d-flex flex-center border-bottom'>
                        <div className='col-lg-3 fw-bolder'>{invoice.invoiceNumber}</div>
                        <div className='col-lg-3'>
                          {formatNumber(invoice.invoiceAmount / (exchangeRate?.exchangeRate ?? 1))}
                        </div>
                        <div className='col-lg-3'>
                          {formatNumber(
                            invoice.settledInvoiceAmount / (exchangeRate?.exchangeRate ?? 1)
                          )}
                        </div>
                        <div className='col-lg-3 '>
                          <input
                            value={invoice.setOffAmount}
                            onChange={(e) => {
                              const invDetails = [...invoiceDetails]
                              invDetails[index].setOffAmount = Number(e.target.value)
                              setInvoiceDetails(invDetails)
                            }}
                            type='number'
                            className='form-control'
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    <span className='fs-4 fw-bold'>No Invoices found</span>
                  </div>
                )}
                <div className='d-flex flex-end'>
                  <button
                    type='reset'
                    onClick={() => setSetOffModal(false)}
                    className='btn btn-light me-3 btn-small'
                    data-kt-users-modal-action='cancel'
                  >
                    Cancel
                  </button>

                  <button
                    type='submit'
                    className='btn btn-primary btn-small'
                    data-kt-users-modal-action='submit'
                    disabled={
                      invoiceDetails?.reduce(
                        (acc, val) => (acc = acc + (val?.setOffAmount || 0)),
                        0
                      ) !== setOffTotalAmount
                    }
                    onClick={handleSetOffLogic}
                  >
                    Save Transaction
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <div className='card'>
          <div className='card-header'>
            <div className='card-title'>
              <Link
                to={previousPath}
                onClick={() => {
                  setPreviousPath(location.pathname)
                }}
              >
                <div
                  data-bs-toggle='tooltip'
                  data-bs-trigger='hover'
                  data-bs-dismiss-='click'
                  title='Go Back'
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  style={{marginRight: '5px'}}
                >
                  <KTIcon iconName='arrow-left' className='fs-2' />
                </div>
              </Link>
              Transaction details
            </div>
          </div>

          <div className='card-body'>
            {multiSetOffData === 'other' && (
              <div className='table-responsive'>
                <table
                  id='view_transactions_table'
                  className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                >
                  <thead>
                    <tr className='text-center text-muted fw-bolder bg-light ps-4 fs-7 text-uppercase gs-0'>
                      <th>Voucher Id</th>
                      <th>Voucher Name</th>
                      <th>Voucher Date</th>
                      <th>Transacting currency</th>
                      {/* <th className='w-300px'>Total Amount</th> */}
                      <th>NARRATIon</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600 fw-bold text-center'>
                    <tr className='text-center'>
                      <td>
                        {voucherMapping?.[activeTab]?.voucherName?.value ||
                          voucherMapping?.[activeTab]?.['None']}
                      </td>
                      <td className='text-capitalize'>
                        {voucherName?.value
                          ? location?.pathname.split('/')[3] + ' - ' + voucherName.value
                          : location?.pathname.split('/')[3]}
                      </td>
                      <td>{voucherDate}</td>
                      <td>
                        <span className='badge badge-primary'>{currency?.value}</span>
                      </td>
                      {/* <td>{tableData?.amount}</td> */}
                      <td>{narration ? narration : '-'}</td>
                    </tr>
                    {data?.map((tableData: any, index: any) => {
                      return (
                        <>
                          {/* {index === 0 && (
                            <tr className='text-center'>
                              <td>{transactionDetails?.transactionDetails?.voucherNumber}</td>
                              <td className='text-capitalize'>
                                {transactionDetails?.transactionDetails?.voucherName
                                  ? location?.pathname.split('/')[3] +
                                    ' - ' +
                                    transactionDetails?.transactionDetails?.voucherName
                                  : location?.pathname.split('/')[3]}
                              </td>
                              <td>{transactionDetails?.transactionDetails?.voucherDate}</td>
                              <td>
                                <span className='badge badge-primary'>
                                  {transactionDetails?.transactionDetails?.transactingCurrency}
                                </span>
                              </td>
                              <td>{tableData?.amount}</td>
                              <td>
                                {transactionDetails?.transactionDetails?.narration
                                  ? transactionDetails?.transactionDetails?.narration
                                  : '-'}
                              </td>
                            </tr>
                          )} */}
                          <tr className='text-center'>
                            <td colSpan={6}>
                              {' '}
                              <span className='fw-bolder text-dark'>
                                {tableData?.parentLedger}
                              </span>{' '}
                              - {tableData?.subLedger}
                              <span
                                className={`${
                                  tableData?.transactionType === 'debit'
                                    ? 'text-danger'
                                    : 'text-success'
                                }`}
                                style={{fontStyle: 'italic'}}
                              >
                                {tableData?.amount}
                                {tableData?.transactionType === 'credit' ? ' CR' : ' DR'}
                              </span>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {multiSetOffData === 'sales' ? salesAndPurchaseView() : otherVoucherView()}

            <div className='card-footer text-end'>
              <button
                className='btn btn-primary me-5'
                disabled={transactionDetails?.length > 0 ? false : true}
                onClick={() => {
                  handleCreateTransaction()
                }}
              >
                Save
              </button>
              <button
                className='btn btn-danger'
                onClick={() => {
                  setModal(true)
                  // navigate(previousPath)
                }}
              >
                Discard
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ImageModal = ({show, onHide, falseStatus}: any) => {
  return (
    <Modals show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          Are you sure you want to discard this transaction? All unsaved changes will be lost.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Display images here */}
        <div className='row'>
          <div className='col-12 text-end'>
            <Button variant='success' className='me-5' onClick={onHide}>
              Cancel
            </Button>
            <Button
              variant='secondary'
              onClick={() => {
                window.history.replaceState({}, '')
                onHide()
                falseStatus()
              }}
            >
              Discard
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modals>
  )
}
